<template>
  <div class="personal-layout" :style="bgColor ? {'background': bgColor} : ''">
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    bgColor: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss">
.personal-layout {
  width: 984px;
  min-height: 600px;
}
</style>


